import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemMailDeleteMailHandlerRoute: InvariantJiraRoute = {
	name: 'global-settings-system-delete-mail-handler',
	path: '/secure/admin/DeleteMailHandler.jspa',
};
